"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
const Place_1 = require("./Place");
const Result_type_1 = require("../../types/Result.type");
const SurveyObjectUnserializer_1 = require("./SurveyObjectUnserializer");
/**
 * Home place class for household home locations
 * Represents the primary residence of a household
 * This is an alias of Place with custom validation display name
 * uuid for home must be equal to the uuid of the household and the uuid of the interview
 */
class Home extends Place_1.Place {
    constructor(dirtyParams, surveyObjectsRegistry) {
        super(dirtyParams, surveyObjectsRegistry);
    }
    /**
     * Creates a Home object from sanitized parameters
     * @param {ExtendedPlaceAttributes | SerializedExtendedPlaceAttributes} params - Sanitized place parameters
     * @returns {Home} New Place instance
     */
    static unserialize(params, surveyObjectsRegistry) {
        const flattenedParams = SurveyObjectUnserializer_1.SurveyObjectUnserializer.flattenSerializedData(params);
        return new Home(flattenedParams, surveyObjectsRegistry);
    }
    /**
     * Factory that validates input and creates a Home object
     * @param {Object} dirtyParams - Raw input parameters to validate
     * @returns {Result<Home>} Either a valid Home object or validation errors
     */
    static create(dirtyParams, surveyObjectsRegistry) {
        const errors = Place_1.Place.validateParams(dirtyParams, 'Home');
        const home = errors.length === 0 ? new Home(dirtyParams, surveyObjectsRegistry) : undefined;
        if (errors.length > 0) {
            return (0, Result_type_1.createErrors)(errors);
        }
        return (0, Result_type_1.createOk)(home);
    }
}
exports.Home = Home;
//# sourceMappingURL=Home.js.map